import React from "react";
import { useMediaQuery } from "react-responsive";
import {
  capitalizeEveryFirstLetter,
  convertToIST12HourFormat,
  NoItemsLeftInTable,
} from "../../../../helpers/helpers";
import TableLoader from "../../../loader/TableLoader";

function LotPriceApprovalTable({ singleOfferData, loadings }) {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });


  if (loadings) {
    return (
      <TableLoader
        headerData={[
          "H-Bidders",
          "Bid Amount",
          "Bid Time",
          "Status",
        ]}
      />
    );
  }

  return (
    <>
      <div className="table-container-style">
        <table
          className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
            }`}
        >
          <thead>
            <tr>
              <th>H-Bidders</th>
              <th>Bid Amount</th>
              <th>Bid Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(singleOfferData?.bids) &&
              [...singleOfferData.bids].reverse().map((item, index) => (
                <tr key={item?._id}>
                  <td>{index + 1}</td>
                  <td>{item?.bidAmount}</td>
                  <td>{convertToIST12HourFormat(item?.createdAt)}</td>
                  <td>{capitalizeEveryFirstLetter(item?.status)}</td>
                </tr>
              ))}

          </tbody>
        </table>
        {singleOfferData?.bids?.length === 0 && <NoItemsLeftInTable />}
      </div>
    </>
  );
}

export default LotPriceApprovalTable;
